import logo from "../Images/img/logo_fit.png";
import form from "../Images/img/form.png";
import form_transport from "../Images/img/form_transport.png";
import logo_qovis from "../Images/img/logo_qovis.png";
import logo_thai from "../Images/img/logo_thai.png";
import notFound from "../Images/img/notFound.png";
import driver_register from "../Images/img/driver_register.png";
import search from "../Images/img/search.png";
import manage_transaction from "../Images/img/manage_transaction.png";
import planning from "../Images/img/planning.png";
import noData from "../Images/img/no-data.svg";
import check_contract from "../Images/img/check_contract.png";
import confirm from "../Images/img/confirm.svg";
import failed from "../Images/img/failed.svg";
import system_maintenance from "../Images/img/system-miantenace.svg";
import serverError from "../Images/img/serverError.svg";
import slotMax from "../Images/img/slotMax.svg";
import noSlot from "../Images/img/noData.svg";

export interface IconInterfaceString {
  [key: string]: string;
}

export const imgList: IconInterfaceString = {
  logo,
  form,
  form_transport,
  logo_qovis,
  logo_thai,
  notFound,
  driver_register,
  search,
  manage_transaction,
  planning,
  noData,
  check_contract,
  confirm,
  failed,
  system_maintenance,
  serverError,
  slotMax,
  noSlot,
};
